const CNPJ_WEIGHTS_FIRST = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const CNPJ_WEIGHTS_SECOND = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

export function normalizeCnpjDigits(value: string): string {
  return value.replace(/\D/g, '').slice(0, 14);
}

export function formatCnpjFieldValue(value: string): string {
  const digits = normalizeCnpjDigits(value);

  if (digits.length <= 2) {
    return digits;
  }
  if (digits.length <= 5) {
    return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  }
  if (digits.length <= 8) {
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  }
  if (digits.length <= 12) {
    return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  }

  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`;
}

export function isValidCnpjDigits(digits: string): boolean {
  if (!/^\d{14}$/.test(digits)) {
    return false;
  }
  if (/^(\d)\1{13}$/.test(digits)) {
    return false;
  }

  const checkDigits = digits.split('').map(Number);

  let sum = 0;
  for (let index = 0; index < 12; index += 1) {
    const digit = checkDigits[index];
    const weight = CNPJ_WEIGHTS_FIRST[index];
    if (digit === undefined || weight === undefined) {
      return false;
    }
    sum += digit * weight;
  }
  let remainder = sum % 11;
  const firstCheck = remainder < 2 ? 0 : 11 - remainder;
  if (firstCheck !== checkDigits[12]) {
    return false;
  }

  sum = 0;
  for (let index = 0; index < 13; index += 1) {
    const digit = checkDigits[index];
    const weight = CNPJ_WEIGHTS_SECOND[index];
    if (digit === undefined || weight === undefined) {
      return false;
    }
    sum += digit * weight;
  }
  remainder = sum % 11;
  const secondCheck = remainder < 2 ? 0 : 11 - remainder;

  return secondCheck === checkDigits[13];
}
